<template>
  <a-modal
    title="旧数据导入"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
          <a-alert
          :closable="true"
          type="info"
          showIcon
          message="该操作将会覆盖现有数据，请谨慎操作！"
          style="margin-bottom: 24px;"
        />
        <a-form-item label="机器人子账户" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['id', { initialValue: currentRobotId }]" read-only/>
        </a-form-item>
        <a-form-item label="上传数据库文件" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <input type="file" ref="database" v-decorator="['database', {rules: [{required: true, message: '必填项'}]}]"/>
        </a-form-item>
      </a-form>
    </a-spin>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button :loading="confirmLoading" type="primary" @click="handleSubmit">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
import DeviceApi from '@/api/device'
export default {
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      mdl: {},
      currentRobotId: '',
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this)
    }
  },
  methods: {
    show(currentRobotId) {
      this.currentRobotId = currentRobotId
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
            const database = this.$refs.database.files[0]
            this.confirmLoading = true
            DeviceApi.saveDbImport({database:database,id:values.id})
              .then((res) => {
                if (res.code === 1) {
                  this.form.resetFields()
                  this.$message.success("导入数据成功");
                  this.visible = false
                  this.$emit('ok')
                } else {
                  this.$message.error(res.msg);
                }
              }).finally(() => {
                this.confirmLoading = false
              })
        }
      })
    }
  }
}
</script>
